// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class EmbeddedWidgetsController {
   $element: any
   $location: any
   $scope: any
   $window: any
   appState: any
   apiService: ApiService
   boxExample: any
   embeddedValues: any
   localization: any
   logo: any
   searchExample: any
   carouselExample: any
   constructor($scope: any, $location: any, appState: any, apiService: ApiService, config: any, $window: any, embeddedValues: any, localization: any, $element: any) {
      this.refreshExamples = this.refreshExamples.bind(this)
      this.goToSearch = this.goToSearch.bind(this)
      this.selectActiveTab = this.selectActiveTab.bind(this)
      this.getSearchParams = this.getSearchParams.bind(this)
      this.getBoxParams = this.getBoxParams.bind(this)
      this.getCarouselParams = this.getCarouselParams.bind(this)
      this.$scope = $scope
      this.$location = $location
      this.appState = appState
      this.apiService = apiService
      this.$window = $window
      this.embeddedValues = embeddedValues
      this.localization = localization
      this.$element = $element
      const {
         assets
      } = config.data
      this.logo = assets.logoSmall
      this.$scope.home = `//${this.$window.location.host}`
      this.$scope.apiResponse = {}
      this.$scope.showResponse = false
      this.$scope.getSearchParams = this.getSearchParams
      this.$scope.getBoxParams = this.getBoxParams
      this.$scope.goToSearch = this.goToSearch
      this.$scope.selectActiveTab = this.selectActiveTab

      this.embeddedValues.showEmbeddedWidgetsBox = true
      this.$scope.embeddedValues = this.embeddedValues
      this.$scope.helpLink = "https://knowledge.exlibrisgroup.com/Summon/Product_Documentation/Configuring_The_Summon_Service/Configurations_Outside_of_the_Summon_Administration_Console/Summon%3A_Creating_a_Search_Box%2C_Search_Widget%2C_or_Carousel"
      // Prevent widgets close without search
      if (this.appState.params.q === undefined) { this.$location.search({q: ''}) }

      // Predefined widget objects
      if (!this.$scope.searchParams) { this.$scope.searchParams = this.embeddedValues.searchParams ||(this.embeddedValues.searchParams =  {
         id: this.genId(),
         logo: this.logo,
         endpoint: this.$scope.home,
         lang: this.localization.getStandardLocale(),
         style: {
            title_color: "#4d4d4d",
            link_color: "#214e95",
            header_color: "#fff",
            results_color: "#fff",
            width: "fixed"
         },
         params: this.appState.params,
         title: "Summon Widget",
         searchbutton_text: "Search"
      }) }

      if (!this.$scope.boxParams) { this.$scope.boxParams = this.embeddedValues.boxParams ||(this.embeddedValues.boxParams =  {
         id: this.genId(),
         endpoint: this.$scope.home,
         style: {
            tagline: "#000",
            links: "#000"
         },
         params: this.appState.params,
         tagline_text: "Easily discover the world of library content",
         searchbutton_text: "Search",
         advanced_text: "More search options",
         placeholder_text: "",
         advanced: true,
         suggest: true,
         tagline: true,
         popup: true
      }) }

      if (!this.$scope.carouselParams) { this.$scope.carouselParams = this.embeddedValues.carouselParams ||(this.embeddedValues.carouselParams =  {
         id: this.genId(),
         endpoint: this.$scope.home,
         style: {
            searchCarouselWidth: "700px",
            card: {
               titleFontColor: "inherit",
               titleFontWeight: "700",
               titleFontSize: "13px",
               descriptionFontColor: "inherit",
               descriptionFontWeight: "400",
               descriptionFontSize: "12px",
               imageHeight: "210px"
            },
            bulletSpacing: "8px"
         },
         webComponentValues: {
            titleText: this.fetchSearchTitleText(),
            titleLink: this.createTitleLinkSummonUrl(),
            defaultThumbnailUrl: `${this.$location.protocol()}:${this.$scope.home}/images/format-large/-generic-grey_64px.png`,
            searchUrl: this.createSearchUrl()
         }
      }) }

      function loadScript (script: string, onLoadFunction: any ) {
         const customJS = document.createElement('script')
         customJS.setAttribute('async', 'true')
         customJS.src = script
         customJS.onload = onLoadFunction
         document.body.appendChild(customJS)
      }

      this.$scope.$watch('embeddedValues.activeWidget', (newValue: any) => {
         let self: any = this
         switch (newValue) {
            case 'box':
               const boxWidgetCallback = () => {
                  if (!self.boxExample) {
                     self.boxExample = self.$window.summonWidget.box(self.$scope.boxParams, 'exampleBoxWidget')
                     self.boxExample.run()
                  } else { self.boxExample.projector.scheduleRender() }
               }
               loadScript(this.$window.boxWidgetScriptSrc, boxWidgetCallback)
               break
            case 'search':
                  const searchWidgetCallback = () => {
                     if (!self.searchExample) {
                        self.searchExample = self.$window.summonWidget.search(self.$scope.searchParams, 'exampleSearchWidget')
                        self.searchExample.run()
                     }
                  }
                  loadScript(this.$window.searchWidgetScriptSrc, searchWidgetCallback)
               break
             case 'carousel':
                 const currentSearch = this.createSearchUrl()
                 const currentTitleText = this.fetchSearchTitleText()
                 const currentTitleLinkSummonUrl = this.createTitleLinkSummonUrl()
                 if (self.$scope.carouselParams.webComponentValues.searchUrl !== currentSearch) {
                     self.$scope.carouselParams.webComponentValues.searchUrl = currentSearch
                     self.$scope.carouselParams.webComponentValues.titleLink = currentTitleLinkSummonUrl
                 }
                 if (self.$scope.carouselParams.webComponentValues.titleText !== currentTitleText) {
                     self.$scope.carouselParams.webComponentValues.titleText = currentTitleText
                 }
                 const carouselWidgetCallback = () => {
                     if (!self.carouselExample) {
                         self.carouselExample = self.$window.summonCarouselWidget.carousel(self.$scope.carouselParams, 'exampleCarouselWidget')
                     }
                 }
                 if (!self.$window.summonWidget?.carousel) {
                     // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
                     loadScript(this.$window.carouselWidgetComponentScriptSrc)
                     loadScript(this.$window.carouselWidgetScriptSrc, carouselWidgetCallback)
                 }
                 break
         }
      })
      // General changes
      this.$scope.$watch('searchParams', () => {
         return this.refreshExamples('search')
      }
      , true)
      this.$scope.$watch('boxParams', () => {
         return this.refreshExamples('box')
      }
      , true)
      this.$scope.$watch('carouselParams', () => {
         return this.refreshExamples('carousel')
      }
      , true)

      // Dynamic height in layout
      const window = angular.element(this.$window)
      const throttled = _.throttle(() => {
         const el = angular.element(this.$element).find('.embeddedWidgets')
         return el.css('height', (angular.element(this.$window).height()) + 'px')
      }
      , 25)
      throttled()
      window.on('resize', throttled)
      // clean up on destroy
      this.$scope.$on('$destroy', () => window.off('resize', throttled))


   }

   createSearchUrl() {
      const params = this.appState.params
      const apiParams : any = this.apiService.apiParamsFor(params)
      delete apiParams.screen_res
      delete apiParams.__refererURL
      let apiParamsString = $.param(apiParams)
      if (apiParamsString.length) { apiParamsString = `?${apiParamsString}` }
      return `${this.$location.protocol()}:${this.$scope.home}/api/search${apiParamsString}`
   }

    createTitleLinkSummonUrl() {
        return `${this.$location.protocol()}:${this.$scope.home}${this.$location.url().replace('widgets', 'search')}`
    }

   fetchSearchTitleText(): string{
      return this.$location.search().q || "Search Results";
   }

   refreshExamples(type: any){
      if (this.boxExample && (type === 'box')) { this.boxExample.projector.scheduleRender() }
      if (this.searchExample && (type === 'search')) { this.searchExample.projector.scheduleRender() }
      if (this.carouselExample && (type === 'carousel')) { this.carouselExample.projector.scheduleRender() }
   }

   goToSearch(turnOff = false){
      this.embeddedValues.showEmbeddedWidgetsBox = !turnOff
      return this.$location.path('/search')
   }

   selectActiveTab(tabName: string) {
      this.embeddedValues.activeTab = tabName
      if(tabName == 'search' && this.embeddedValues.activeWidget === 'carousel') {
         this.goToSearch()
      }
   }

   getSearchParams() {
      return JSON.stringify(this.cleanParams(angular.copy(this.$scope.searchParams)))
   }

   getBoxParams() {
      return JSON.stringify(this.cleanParams(angular.copy(this.$scope.boxParams)))
   }

   getCarouselParams() {
      return JSON.stringify(this.cleanParams(angular.copy(this.$scope.carouselParams)))
   }

   cleanParams(opts: any){
      opts.params.pn = 1
      if (opts.params.q != null) { delete opts.params.q }
      if (opts.params.rf.length === 0) { delete opts.params.rf }
      if (opts.params.fvfi.length === 0) { delete opts.params.fvfi }
      if (opts.params.fvf.length === 0) { delete opts.params.fvf }
      return opts
   }

   genId() {
      return 'sxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c){
         const r = (Math.random() * 16) | 0
         return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16)
      })
   }
}


EmbeddedWidgetsController.$inject = ['$scope', '$location', 'appStateService', 'apiService', 'configService', '$window', 'embeddedWidgetValues', 'localizationService', '$element']

angular.module('summonApp.controllers')
   .controller('EmbeddedWidgetsCtrl', EmbeddedWidgetsController)
